import React from "react";

const TemarioCursoOperadorPrehospitalarioEmergencias = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Principios generales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Principios generales de atención en emergencias prehospitalarias"}</span></li>
                <li><span className="fw-light">{"Sistemas de Atención Médica de Emergencia"}</span></li>
                <li><span className="fw-light">{"Componentes del sistema de emergencias"}</span></li>
                <li><span className="fw-light">{"Toma de decisiones críticas"}</span></li>
            </ul>
            <br /><br />
            <b>{"La escena"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Valoración de la escena"}</span></li>
                <li><span className="fw-light">{"Seguridad de la escena"}</span></li>
                <li><span className="fw-light">{"Características del llamado"}</span></li>
                <li><span className="fw-light">{"Número de pacientes y suficiencia de recursos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Sistemas corporales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Localización de órganos y estructuras corporales"}</span></li>
                <li><span className="fw-light">{"Sistema músculo esquelético"}</span></li>
                <li><span className="fw-light">{"Sistema respiratorio"}</span></li>
                <li><span className="fw-light">{"Sistema cardiovascular"}</span></li>
                <li><span className="fw-light">{"Sistema linfático"}</span></li>
                <li><span className="fw-light">{"Sistema nervioso"}</span></li>
                <li><span className="fw-light">{"Sistema digestivo"}</span></li>
                <li><span className="fw-light">{"Sistema endocrino"}</span></li>
                <li><span className="fw-light">{"Sistema renal"}</span></li>
                <li><span className="fw-light">{"Sistema reproductivo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fisiopatología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"La célula"}</span></li>
                <li><span className="fw-light">{"Características"}</span></li>
                <li><span className="fw-light">{"Procesos biológicos"}</span></li>
                <li><span className="fw-light">{"Vulnerabilidad de las células, órganos y sistemas orgánicos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Signos vitales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Signos vitales y dispositivos de vigilancia"}</span></li>
                <li><span className="fw-light">{"Registro de signos vitales. Signos vitales. Pulso"}</span></li>
                <li><span className="fw-light">{"Respiración. Piel. Pupilas. Presión arterial"}</span></li>
                <li><span className="fw-light">{"Temperatura. Saturación de oxígeno. Medidores de glucosa sanguínea"}</span></li>
            </ul>
            <br /><br />
            <b>{"La vía aérea"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Manejo de la vía aérea"}</span></li>
                <li><span className="fw-light">{"Fisiopatología de la vía aérea. Apertura de la vía aérea. Maniobra de inclina-"}</span></li>
                <li><span className="fw-light">{"Ción de la cabeza y levantamiento del mentón"}</span></li>
                <li><span className="fw-light">{"Maniobra modificada de mandíbula"}</span></li>
                <li><span className="fw-light">{"Dispositivos adyuvantes para la vía aérea"}</span></li>
                <li><span className="fw-light">{"Reglas para el uso de dispositivos adyuvantes para la vía aérea. Cánula oro"}</span></li>
                <li><span className="fw-light">{"Faríngea. Cánula nasofaríngea"}</span></li>
                <li><span className="fw-light">{"Aspiración. Dispositivos para aspiración"}</span></li>
                <li><span className="fw-light">{"Técnicas de aspiración"}</span></li>
                <li><span className="fw-light">{"Mantenimiento de una vía aérea abierta: manejo definitivo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Shock"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Los distintos tipos de Shock"}</span></li>
                <li><span className="fw-light">{"Shock hipovolémico"}</span></li>
                <li><span className="fw-light">{"Traumatismo y trastorno complejo del flujo sanguíneo"}</span></li>
                <li><span className="fw-light">{"Reducción de la perfusión"}</span></li>
                <li><span className="fw-light">{"Disminución crítica del volumen intravascular"}</span></li>
                <li><span className="fw-light">{"La oxigenación tisular"}</span></li>
                <li><span className="fw-light">{"Shock cardiogénico"}</span></li>
                <li><span className="fw-light">{"La hipoperfusión tisular y la disminución de la perfusión tisular"}</span></li>
                <li><span className="fw-light">{"Shock obstructivo: La obstrucción mecánica y la obstrucción aguda"}</span></li>
                <li><span className="fw-light">{"Salidas ventriculares"}</span></li>
                <li><span className="fw-light">{"Compresión cardiaca"}</span></li>
                <li><span className="fw-light">{"Shock distributivo"}</span></li>
                <li><span className="fw-light">{"La vasodilatación sistémica profunda disminución del volumen intravascular"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aspectos médico-legales y éticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Abandono de persona y omisión de auxilio"}</span></li>
                <li><span className="fw-light">{"Rechazo de atención"}</span></li>
                <li><span className="fw-light">{"Órdenes de no reanimar"}</span></li>
                <li><span className="fw-light">{"Indicaciones del médico para medidas de soporte vital"}</span></li>
            </ul>
            <br /><br />
            <b>{"Paro cardiorespiratorio"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cadena de sobrevivencia"}</span></li>
                <li><span className="fw-light">{"Manejo del paro cardiorrespiratorio"}</span></li>
                <li><span className="fw-light">{"Desfibrilador automático externo"}</span></li>
                <li><span className="fw-light">{"Consideraciones especiales para el uso del desfibrilador automático externo"}</span></li>
                <li><span className="fw-light">{"Dispositivos mecánicos para reanimación cardiopulmonar"}</span></li>
                <li><span className="fw-light">{"Terminación de la reanimación"}</span></li>
            </ul>
            <br /><br />
            <b>{"PCR"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"PCR en situaciones especiales"}</span></li>
                <li><span className="fw-light">{"El paro cardiorespiratorio"}</span></li>
                <li><span className="fw-light">{"Embarazadas"}</span></li>
                <li><span className="fw-light">{"Politraumas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Quemaduras"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Clasificación de las quemaduras de acuerdo con el agente y la fuente"}</span></li>
                <li><span className="fw-light">{"Clasificación de las quemaduras con base en su profundidad"}</span></li>
                <li><span className="fw-light">{"Determinación y clasificación de la gravedad de las quemaduras"}</span></li>
                <li><span className="fw-light">{"Tratamiento de tipos específicos de quemaduras"}</span></li>
                <li><span className="fw-light">{"Ácidos y álcalis"}</span></li>
                <li><span className="fw-light">{"Quemaduras radiológicas"}</span></li>
                <li><span className="fw-light">{"Lesiones eléctricas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Evaluación primaria y secundaria"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Evaluación primaria"}</span></li>
                <li><span className="fw-light">{"Realización de la evaluación primaria. Motivo de consulta principal. Valoración"}</span></li>
                <li><span className="fw-light">{"Del ABC"}</span></li>
                <li><span className="fw-light">{"Valoración del estado mental. Determinación de la prioridad"}</span></li>
                <li><span className="fw-light">{"Evaluación secundaria"}</span></li>
                <li><span className="fw-light">{"Componentes de la evaluación secundaria"}</span></li>
                <li><span className="fw-light">{"Técnicas de valoración"}</span></li>
                <li><span className="fw-light">{"Exploración de sistemas corporales. Sistema respiratorio. Sistema"}</span></li>
                <li><span className="fw-light">{"Cardiovascular"}</span></li>
                <li><span className="fw-light">{"Sistema nervioso"}</span></li>
                <li><span className="fw-light">{"Sistema endocrino"}</span></li>
                <li><span className="fw-light">{"Sistema digestivo"}</span></li>
                <li><span className="fw-light">{"Sistema inmunitario"}</span></li>
                <li><span className="fw-light">{"Sistema musculo esquelético"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias respiratorias"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Urgencias respiratorias"}</span></li>
                <li><span className="fw-light">{"Respiración. Respiración adecuada. Respiración inadecuada"}</span></li>
                <li><span className="fw-light">{"Ventilación artificial adecuada e inadecuada"}</span></li>
                <li><span className="fw-light">{"Dificultad respiratoria"}</span></li>
                <li><span className="fw-light">{"Presión positiva continua en la vía aérea"}</span></li>
                <li><span className="fw-light">{"Trastornos respiratorios"}</span></li>
                <li><span className="fw-light">{"Enfermedad pulmonar obstructiva crónica"}</span></li>
                <li><span className="fw-light">{"Asma"}</span></li>
                <li><span className="fw-light">{"Edema pulmonar"}</span></li>
                <li><span className="fw-light">{"Neumonía"}</span></li>
                <li><span className="fw-light">{"Neumotórax espontáneo"}</span></li>
                <li><span className="fw-light">{"Embolia pulmonar"}</span></li>
                <li><span className="fw-light">{"Epiglotitis"}</span></li>
                <li><span className="fw-light">{"Infecciones respiratorias de origen viral"}</span></li>
                <li><span className="fw-light">{"Fármacos para inhalación"}</span></li>
            </ul>
            <br /><br />
            <b>{"Respiración y ventilación artificial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiopatología"}</span></li>
                <li><span className="fw-light">{"Mecánica respiratoria"}</span></li>
                <li><span className="fw-light">{"Fisiopatología del sistema cardiopulmonar"}</span></li>
                <li><span className="fw-light">{"Ventilación con presión positiva"}</span></li>
                <li><span className="fw-light">{"Técnicas de ventilación artificial"}</span></li>
                <li><span className="fw-light">{"Oxigenoterapia"}</span></li>
                <li><span className="fw-light">{"Importancia del oxígeno suplementario"}</span></li>
                <li><span className="fw-light">{"Equipo para oxigenoterapia"}</span></li>
                <li><span className="fw-light">{"Riesgos de la oxigenoterapia"}</span></li>
                <li><span className="fw-light">{"Administración de oxígeno. Cálculo de uso"}</span></li>
                <li><span className="fw-light">{"Asistencia para el uso de dispositivos avanzados para la vía aérea"}</span></li>
                <li><span className="fw-light">{"Ventilación del paciente intubado"}</span></li>
                <li><span className="fw-light">{"Asistencia en la intubación en el paciente con traumatismo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias abdominales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Dolor o malestares abdominales. Valoración del dolor abdominal. Valoración"}</span></li>
                <li><span className="fw-light">{"De la escena"}</span></li>
                <li><span className="fw-light">{"Evaluación primaria"}</span></li>
                <li><span className="fw-light">{"Interrogatorio clínico"}</span></li>
                <li><span className="fw-light">{"Exploración física del abdomen. Signos vitales"}</span></li>
                <li><span className="fw-light">{"Malestar abdominal generalizado"}</span></li>
                <li><span className="fw-light">{"Afecciones abdominales"}</span></li>
                <li><span className="fw-light">{"Apendicitis"}</span></li>
                <li><span className="fw-light">{"Peritonitis"}</span></li>
                <li><span className="fw-light">{"Colecistitis/colelitiasis"}</span></li>
                <li><span className="fw-light">{"Pancreatitis"}</span></li>
                <li><span className="fw-light">{"Hemorragia gastrointestinal"}</span></li>
                <li><span className="fw-light">{"Aneurisma aórtico abdominal"}</span></li>
                <li><span className="fw-light">{"Hernia"}</span></li>
                <li><span className="fw-light">{"Cólico renal"}</span></li>
                <li><span className="fw-light">{"Patología cardiaca"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias diabéticas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Fisiopatología"}</span></li>
                <li><span className="fw-light">{"Diabetes"}</span></li>
                <li><span className="fw-light">{"Insulina y páncreas"}</span></li>
                <li><span className="fw-light">{"Hipoglucemia. Hiperglucemia"}</span></li>
                <li><span className="fw-light">{"Glucómetros"}</span></li>
            </ul>
            <br /><br />
            <b>{"Reacción alérgica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Diferenciación de la anafilaxia de una reacción alérgica leve"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias obstétricas y ginecológicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cambios fisiológicos en el embarazo. Cambios fisiológicos en el embarazo"}</span></li>
                <li><span className="fw-light">{"Trabajo de parto y parto. Etapas del trabajo de parto"}</span></li>
                <li><span className="fw-light">{"Valoración de la paciente. Valoración de la mujer en trabajo de parto"}</span></li>
                <li><span className="fw-light">{"Parto normal"}</span></li>
                <li><span className="fw-light">{"El recién nacido"}</span></li>
                <li><span className="fw-light">{"Valoración del recién nacido"}</span></li>
                <li><span className="fw-light">{"Atención del recién nacido"}</span></li>
                <li><span className="fw-light">{"Atención después del parto"}</span></li>
                <li><span className="fw-light">{"Atención a la madre"}</span></li>
                <li><span className="fw-light">{"Alumbramiento de la placenta"}</span></li>
                <li><span className="fw-light">{"Control del sangrado vaginal después del nacimiento"}</span></li>
                <li><span className="fw-light">{"Complicaciones del parto"}</span></li>
                <li><span className="fw-light">{"Complicaciones del nacimiento"}</span></li>
                <li><span className="fw-light">{"Urgencias en el embarazo"}</span></li>
                <li><span className="fw-light">{"Urgencias ginecológicas"}</span></li>
                <li><span className="fw-light">{"Hemorragia vaginal"}</span></li>
                <li><span className="fw-light">{"Traumatismo a los genitales externos"}</span></li>
                <li><span className="fw-light">{"Violencia sexual"}</span></li>
            </ul>
            <br /><br />
            <b>{"Crecimiento y desarrollo vital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Crecimiento y desarrollo vital"}</span></li>
                <li><span className="fw-light">{"Lactancia (del nacimiento al primer año)"}</span></li>
                <li><span className="fw-light">{"Fisiológico y Psicosocial de lactante mayor, edad preescolar, edad escolar,"}</span></li>
                <li><span className="fw-light">{"Adultez temprana, adultez intermedia y adultez mayor"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias pediátricas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Características del desarrollo de lactantes y niños. Diferencias anatómicas y fisiológicas."}</span></li>
                <li><span className="fw-light">{"Características psicológicas y de la personalidad"}</span></li>
                <li><span className="fw-light">{"Interacción con el paciente pediátrico"}</span></li>
                <li><span className="fw-light">{"Paciente adolescente"}</span></li>
                <li><span className="fw-light">{"Valoración del paciente pediátrico. Triángulo de la valoración pediátrica"}</span></li>
                <li><span className="fw-light">{"Valoración de la escena y seguridad pediátricas"}</span></li>
                <li><span className="fw-light">{"Evaluación primaria pediátricas. Evaluación secundaria pediátricas"}</span></li>
                <li><span className="fw-light">{"Exploración física pediátricas"}</span></li>
                <li><span className="fw-light">{"Revaloración pediátrica. Comparación de valoraciones"}</span></li>
                <li><span className="fw-light">{"Consideraciones especiales en la atención pediátrica"}</span></li>
                <li><span className="fw-light">{"Mantenimiento de la vía aérea. Posición de la vía aérea. Eliminación de una"}</span></li>
                <li><span className="fw-light">{"Obstrucción en la vía aérea"}</span></li>
                <li><span className="fw-light">{"Soporte vital básico del lactante y el niño"}</span></li>
                <li><span className="fw-light">{"Suministro de oxígeno suplementario y ventilaciones"}</span></li>
                <li><span className="fw-light">{"Atención para el shock"}</span></li>
                <li><span className="fw-light">{"Protección contra la hipotermia"}</span></li>
                <li><span className="fw-light">{"Urgencias médicas pediátricas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Manejo de urgencias pediátricas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Trastornos respiratorios. Otros trastornos pediátricos"}</span></li>
                <li><span className="fw-light">{"Urgencias traumatológicas pediátricas"}</span></li>
                <li><span className="fw-light">{"Patrones de lesión"}</span></li>
                <li><span className="fw-light">{"Quemaduras"}</span></li>
                <li><span className="fw-light">{"Maltrato y negligencia infantil"}</span></li>
                <li><span className="fw-light">{"Maltrato infantil y abuso sexual"}</span></li>
                <li><span className="fw-light">{"Rol del OPE en casos de sospecha de maltrato o negligencia"}</span></li>
                <li><span className="fw-light">{"Lactantes y niños con problemas especiales"}</span></li>
                <li><span className="fw-light">{"Sondas de traqueotomía"}</span></li>
                <li><span className="fw-light">{"Ventiladores artificiales domésticos"}</span></li>
                <li><span className="fw-light">{"Catéteres intravenosos centrales"}</span></li>
                <li><span className="fw-light">{"Sondas de gastrostomía y alimentación gástrica"}</span></li>
                <li><span className="fw-light">{"Derivación ventriculoperitoneal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Urgencias por envenenamiento"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Envenenamiento. Venenos ingeridos. Venenos"}</span></li>
                <li><span className="fw-light">{"Inhalados. Venenos absorbidos. Venenos inyectados"}</span></li>
                <li><span className="fw-light">{"Centros de información toxicológica"}</span></li>
                <li><span className="fw-light">{"Consumo excesivo de alcohol"}</span></li>
                <li><span className="fw-light">{"Consumo excesivo de sustancias"}</span></li>
            </ul>
            <br /><br />
            <b>{"Tratamientos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Traumatismos en tejidos blandos"}</span></li>
                <li><span className="fw-light">{"Traumatismos cerrados"}</span></li>
                <li><span className="fw-light">{"Tipos de heridas cerradas"}</span></li>
                <li><span className="fw-light">{"Atención de urgencia para lesiones cerradas"}</span></li>
                <li><span className="fw-light">{"Lesiones. Tipos de lesiones"}</span></li>
                <li><span className="fw-light">{"Cuidado de urgencias para las heridas"}</span></li>
                <li><span className="fw-light">{"Tratamiento de tipos específicos de heridas"}</span></li>
                <li><span className="fw-light">{"Tratamiento de abrasiones y laceraciones"}</span></li>
                <li><span className="fw-light">{"Tratamiento de traumatismo penetrante"}</span></li>
                <li><span className="fw-light">{"Tratamiento de heridas por empalamiento de objetos"}</span></li>
                <li><span className="fw-light">{"Tratamiento de las avulsiones"}</span></li>
                <li><span className="fw-light">{"Tratamiento de amputaciones"}</span></li>
                <li><span className="fw-light">{"Tratamiento de lesiones genitales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Politraumatismo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Politraumatismo"}</span></li>
                <li><span className="fw-light">{"Determinación de la gravedad del paciente"}</span></li>
                <li><span className="fw-light">{"Lesiones internas"}</span></li>
                <li><span className="fw-light">{"Toma de decisiones críticas"}</span></li>
                <li><span className="fw-light">{"Principios generales del tratamiento del politraumatizado"}</span></li>
                <li><span className="fw-light">{"Calificación del traumatismo"}</span></li>
            </ul>
            <br /><br />
            <b>{"Eventos con víctimas múltiples"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Seguridad, manejo de escena y escenario, tipos de escenarios,"}</span></li>
                <li><span className="fw-light">{"Características del incidente"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioCursoOperadorPrehospitalarioEmergencias;
